import { Modal } from 'components/Modal'
import { RefreshIcon } from '@heroicons/react/outline'

interface Props {
  open: boolean
  clientName: string
  billingPeriod: string
  onConfirm: () => void
  onClose: () => void
}

export function RegenerateInvoiceModal({
  open,
  clientName,
  billingPeriod,
  onConfirm,
  onClose
}: Props) {
  return (
    <Modal open={open} title="Regenerar faturas" onClose={onClose}>
      <div className="flex flex-col gap-4 mt-4 pr-4">
        <p className="text-sm text-gray-600">
          Todas as faturas de{' '}
          <span className="font-semibold text-gray-900">{clientName}</span> a
          partir de{' '}
          <span className="font-semibold text-gray-900">{billingPeriod}</span>{' '}
          serão excluídas e regeradas do zero com base nos dados atuais de
          assinaturas e itens.
        </p>
        <p className="text-sm text-gray-600">
          Faturas já pagas ou canceladas{' '}
          <span className="font-semibold">não serão afetadas</span>. Apenas
          faturas em rascunho ou abertas entrarão no processo de regeneração.
        </p>
        <p className="text-sm text-amber-600 font-medium">
          Esta ação não pode ser desfeita.
        </p>
        <div className="flex justify-end gap-3 mt-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-transparent bg-emerald-600 text-sm font-medium text-white hover:bg-emerald-700 focus:outline-none"
          >
            <RefreshIcon className="h-4 w-4" />
            Regenerar
          </button>
        </div>
      </div>
    </Modal>
  )
}
